import { PaginationOptions } from 'mbs-ui-kit';

export function showPagination(options: PaginationOptions): boolean {
  return options.pageSize > 0 && options.pageSize < options.dataSize && options.dataSize > 0;
}
